import React, {useRef, useState} from 'react';
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';

import {FORM} from "../../../components/i18n/i18n";
import {
    ButtonCancel,
    ButtonEdit,
    ButtonNew,
    ButtonSubmit,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import {useForm} from "react-hook-form";
import {showLoader} from "../../../components/loader/loader";
import {FL_CODE, FL_ID, FL_NAME, FL_ORDER, FL_STATUS} from "../../../components/i18n/formLabels";
import {PH_CODE, PH_NAME} from "../../../components/i18n/placeHolders";
import Switch from "react-bootstrap-switch";
import {typeDestinationActivityService} from "../../../jwt/_services/xailing/typeDestinationActivityService";
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";

export default function TypeDestinationActivityForm(props) {

    const [editMode, setEditMode] = useState(!!props?.item?.id);
    const [disableInputs, setDisableInputs] = useState(false);
    const [saveSuccess, setSaveSuccess] = useState(false);
    const [savedData, setSavedData] = useState(editMode ? props.item : null);
    const [status, setStatus] = useState(editMode ? props.item?.status : false);
    const [loading, setLoading] = useState(false);

    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(savedData);
    }

    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            id: savedData?.id,

            code: savedData?.code,
            name: savedData?.name,
            showOrder: savedData?.showOrder,
        }
    });

    const onSubmit = (data, _) => {
        setLoading(true);
        const dataRequest = {
            id: data.id,

            code: data.code,
            name: data.name,
            showOrder: data.showOrder,
            status: status
        };

        if (!editMode) {
            //Save
            return typeDestinationActivityService.saveItem(dataRequest)
                .then(resultData => {
                    setResult(resultData);
                })
                .catch(_ => {
                    setLoading(false);
                });
        } else {
            //Update
            let id = savedData.id;

            return typeDestinationActivityService.updateItem(id, dataRequest)
                .then(resultData => {
                    setResult(resultData);
                })
                .catch(_ => {
                    setLoading(false);
                });
        }
    };

    const setResult = (resultData) => {
        setLoading(false);
        setSavedData(resultData);
        setDisableInputs(true);
        setSaveSuccess(true);
        setEditMode(true);
    }

    const resetForm = () => {
        setSavedData(null);
        setEditMode(false);
        setDisableInputs(false);
        setSaveSuccess(false);
        reset();
    }

    const beginEdit = () => {
        setEditMode(true);
        setSaveSuccess(false)
        setDisableInputs(false);
    }

    const setForm = () => {
        props.setForm(null, null, "LIST");
    }

    return (
        <Card>
            {loading ? showLoader() : null}
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label>{FL_ID}</Label>
                                <Input type="id" name="id" id="id"
                                       disabled
                                       value={editMode ? savedData?.id : ''}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <Label>{FL_CODE}</Label>
                                <Input type="text" name="code"
                                       placeholder={PH_CODE}
                                       innerRef={register}
                                       disabled={disableInputs}/>
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>{FL_NAME}</Label>
                                <Input type="text" name="name"
                                       placeholder={PH_NAME}
                                       innerRef={register}
                                       disabled={disableInputs}/>
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>{FL_ORDER}</Label>
                                <Input type="number" name="showOrder"
                                       placeholder="0"
                                       step="1"
                                       innerRef={register}
                                       disabled={disableInputs}/>
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>{FL_STATUS}</Label>
                                <br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        value={status}
                                        disabled={disableInputs}
                                        onChange={() => setStatus(!status)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <CardBody className="border-top">
                        {
                            saveSuccess ?
                                <div className="float-right">
                                    <ButtonNew onClick={() => { resetForm() }}/>
                                    <ButtonEdit onClick={() => {  beginEdit() }}/>
                                    <ButtonCancel onClick={setForm}/>
                                </div>
                                : <div className="float-right">
                                    <ButtonSubmit/>
                                    <ButtonCancel onClick={setForm}/>
                                </div>
                        }
                    </CardBody>
                </Form>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ savedData }
                />
            }
        </Card>
    )
}